import { FiAlertCircle } from "react-icons/fi";

export default function CrudSelect({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Select",
  required = false,
  disabled = false,
  error = "",
}) {
  return (
    <div>
      {label && (
        <label className="mb-2 block font-semibold text-navy-700">
          {label}

          {required && (
            <span className="ml-1 text-red-500">*</span>
          )}
        </label>   
      )}

      <select
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`
          w-full rounded-xl border p-3 outline-none transition
          ${
            error
              ? "border-red-500 focus:border-red-500"
              : "border-gray-300 focus:border-brand-500"
          }
          ${
            disabled
              ? "cursor-not-allowed bg-gray-100"
              : "bg-white"
          }
        `}
      >
        <option value="">
          {placeholder}
        </option>

        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>

      {error && (
        <p className="mt-1 flex items-center gap-1 text-sm text-red-500">
          <FiAlertCircle size={14} />
          {error}
        </p>
      )}
    </div>
  );
}